import { default as Breadcrumbs } from '@jetshop/ui/Breadcrumbs';
import React,{useContext} from 'react';
import { styled } from 'linaria/react';
import UIMaxWidth from '../Layout/MaxWidth';
import { LoadingLine } from '@jetshop/ui/Loading/LoadingLine';
import { theme } from '../Theme';
import { Helmet } from 'react-helmet-async';
import ChannelContext from '@jetshop/core/components/ChannelContext';

const Header = styled('h1')`
  font-size: 30px;
  font-weight: 600;
  margin: 1rem 0 3rem;
  text-align: center;
`;

const Content = styled('div')`
  padding-bottom: 1rem;
  margin-bottom: 3rem;

  a {
    color: ${theme.colors.accent};
    transition: all ease 0.3s;
  }

  ul {
    display: block;
    list-style-type: disc;
    margin-left: 1rem;
    margin-bottom: 1rem;
  }

  td {
    background: none;
  }

  th {
    background: ${theme.colors.lightgrey};
  }

  td,
  th,
  tr {
    padding: 5px 10px;
  }

  tr:nth-child(even) {
    background-color: ${theme.colors.background};
  }

  a:hover {
    color: ${theme.colors.black};
  }

  p {
    margin-bottom: 1rem;
  }

  #brodyr {
    background: #fff;

    td {
      padding: 5px 0;
    }

    tr {
      background-color: #fff;
    }
  }
`;

const MaxWidth = styled(UIMaxWidth)`
  max-width: 60rem;
`;

export const StyledBreadcrumbs = styled(Breadcrumbs)`
  margin-bottom: 30px;
  margin-top: 1.5rem;
  a,
  li {
    font-size: 11px;
    color: ${theme.colors.primary};
    text-decoration: none;
  }
  a {
    font-weight: normal;
  }
  li {
    font-weight: bold;
  }
`;


const FreshDeskInject = () => {
const { selectedChannel } = useContext(ChannelContext);
if(selectedChannel.id !== 1) return null;
return (
  <Helmet>
    <script>
	{`window.fwSettings={
	'widget_id':103000005801,
	'locale': '${selectedChannel.defaultLanguage.culture}',
	};
	!function(){if("function"!=typeof window.FreshworksWidget){var n=function(){n.q.push(arguments)};n.q=[],window.FreshworksWidget=n}}()`}
</script>
<script type='text/javascript' src='https://euc-widget.freshworks.com/widgets/103000005801.js' async defer></script>
  </Helmet>
)
}

function ContentPage(props, parents) {
  const { result, cacheHit } = props;
  const breadcrumbProps = {
    breadcrumbText: result.data
      ? result?.data?.route?.object?.breadcrumbText
      : null,
    parents
  };
  return (
    <>
      {parseInt(props?.page?.id ?? 0) === 48 && <FreshDeskInject />}

      <MaxWidth>
        {/* {result?.data?.route?.object && (
          <StyledBreadcrumbs {...breadcrumbProps} />
        )} */}

        <Header>
          {result?.data?.route?.object.name ? (
            result.data.route.object.name
          ) : (
            <LoadingLine heightPx={27} widthRem={15} />
          )}
        </Header>
      </MaxWidth>

      <MaxWidth>
        {result?.data?.route?.object ? (
          <>
            <Content
              dangerouslySetInnerHTML={{
                __html: result.data.route.object.content
              }}
            />
          </>
        ) : (
          <LoadingLine
            heightPx={14}
            widthRem={30}
            randomizeWidthBy={10}
            count={10}
            style={{
              marginBottom: '12px'
            }}
          />
        )}
      </MaxWidth>
    </>
  );
}

export default ContentPage;
